/* HEAVELYN — gallery.js (mobile carousel <-> thumbnail sync) */
(function () {
  'use strict';
  var gallery = document.querySelector('.product-gallery');
  var thumbs = document.querySelector('[data-gallery-thumbs]');
  if (!gallery || !thumbs) return;

  var buttons = Array.prototype.slice.call(thumbs.querySelectorAll('[data-thumb-index]'));
  var count = gallery.children.length;

  function setActive(i) {
    buttons.forEach(function (b, bi) { b.classList.toggle('is-active', bi === i); });
    var active = buttons[i];
    if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var i = parseInt(btn.getAttribute('data-thumb-index'), 10);
      gallery.scrollTo({ left: i * gallery.clientWidth, behavior: 'smooth' });
      setActive(i);
    });
  });

  var timer;
  gallery.addEventListener('scroll', function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
      setActive(Math.max(0, Math.min(count - 1, idx)));
    }, 80);
  }, { passive: true });
})();
